import dayjs from 'dayjs'
import 'dayjs/locale/sl'
import 'dayjs/locale/en'
import 'dayjs/locale/fr'
import 'dayjs/locale/de'
import 'dayjs/locale/hr'
import type { DateValue } from '@internationalized/date'

// Keep dates/calendars in sync with the active app locale (called from the app store).
export const setDayjsLocale = (locale: string) => {
    dayjs.locale(locale)
}

// Display a CalendarDate / CalendarDateTime (from @internationalized/date) as a plain
// string for a picker trigger. `minute` granularity appends the time. Kept here so the
// shared DatePickerPopover formats consistently through dayjs (matches formatDate /
// formatDateTime elsewhere: DD/MM/YYYY [HH:mm]).
export const formatCalendarValue = (
    value: DateValue | null | undefined,
    granularity: 'day' | 'minute' = 'day',
): string => {
    if (!value) return ''
    const hasTime = 'hour' in value
    const d = dayjs(new Date(
        value.year,
        value.month - 1,
        value.day,
        hasTime ? (value as { hour: number }).hour : 0,
        hasTime ? (value as { minute: number }).minute : 0,
    ))
    if (!d.isValid()) return ''
    return d.format(granularity === 'minute' ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY')
}

export default dayjs
